"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tip = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

exports.Tip = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  pointer-events: none;\n  opacity: 0;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.2s ease;\n\n  @media (min-width: 424px) {\n    max-width: 25rem;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  pointer-events: none;\n  opacity: 0;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.2s ease;\n\n  @media (min-width: 424px) {\n    max-width: 25rem;\n  }\n\n  ", "\n"])), function (_a) {
  var entering = _a.entering;
  return entering && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      opacity: 1;\n    "], ["\n      opacity: 1;\n    "])));
});
var templateObject_1, templateObject_2;